import React, { useState } from 'react';
import { Camera } from 'lucide-react';

const VendorAmenities = ({ services = [], categories = [] }) => {
  const [showAll, setShowAll] = useState(false);

  const amenities = [];

  categories.forEach((category) => {
    if (category?.category_name) {
      amenities.push({
        icon: Camera,
        label: category.category_name,
      });
    }
  });

  const visibleAmenities = showAll ? amenities : amenities.slice(0, 10);
  const hasMore = amenities.length > 10;

  if (amenities.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {visibleAmenities.map((amenity, index) => {
          const Icon = amenity.icon;
          return (
            <div key={index} className="flex items-center gap-3">
              <Icon className="h-5 w-5 shrink-0 text-m-ink" />
              <span className="text-sm text-m-ink-muted sm:text-base">{amenity.label}</span>
            </div>
          );
        })}
      </div>

      {hasMore ? (
        <button
          type="button"
          onClick={() => setShowAll(!showAll)}
          className="mt-4 text-sm font-medium text-m-ink underline underline-offset-2 transition-opacity hover:opacity-70"
        >
          {showAll ? 'Show less' : `Show all ${amenities.length} amenities`}
        </button>
      ) : null}
    </div>
  );
};

export default VendorAmenities;
